import { render } from "./add-clinic-appointment.vue?vue&type=template&id=745c06ab"
import script from "./add-clinic-appointment.vue?vue&type=script&lang=js"
export * from "./add-clinic-appointment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__